<span class="vue-labelled-checkbox-root" @click="toggle"><CheckboxIcon class="checkbox" :checked="modelValue"></CheckboxIcon>
<Label tag="div" :text="label" @click="toggle"></Label></span>